// The fixed preset icon library admins choose from when creating or
// editing a publication (magazine). Keys must stay in sync with
// domain.ValidIconKeys on the backend — the backend only ever stores the
// key, never SVG markup. All icons share the same line-art style used
// across the site: viewBox 0 0 64 64, stroke=currentColor, fill=none,
// strokeWidth=1.
import React from "react";

export const PUBLICATION_ICONS = [
  {
    key: "timber",
    label: "حلقه‌های چوب",
    svg: (
      <svg viewBox="0 0 64 64" aria-hidden="true">
        <circle cx="32" cy="32" r="26" strokeWidth="1" stroke="currentColor" fill="none" />
        <circle cx="32" cy="32" r="18" strokeWidth="1" stroke="currentColor" fill="none" />
        <circle cx="32" cy="32" r="10" strokeWidth="1" stroke="currentColor" fill="none" />
        <circle cx="32" cy="32" r="2.5" strokeWidth="1" stroke="currentColor" fill="none" />
        <line x1="32" y1="6" x2="32" y2="0" strokeWidth="1" stroke="currentColor" />
      </svg>
    ),
  },
  {
    key: "steel-glass",
    label: "نمای شیشه‌ای",
    svg: (
      <svg viewBox="0 0 64 64" aria-hidden="true">
        <rect x="8" y="8" width="48" height="48" strokeWidth="1" stroke="currentColor" fill="none" />
        <line x1="8" y1="24" x2="56" y2="24" strokeWidth="1" stroke="currentColor" />
        <line x1="8" y1="40" x2="56" y2="40" strokeWidth="1" stroke="currentColor" />
        <line x1="24" y1="8" x2="24" y2="56" strokeWidth="1" stroke="currentColor" />
        <line x1="40" y1="8" x2="40" y2="56" strokeWidth="1" stroke="currentColor" />
      </svg>
    ),
  },
  {
    key: "urban",
    label: "خط آسمان شهر",
    svg: (
      <svg viewBox="0 0 64 64" aria-hidden="true">
        <line x1="4" y1="56" x2="60" y2="56" strokeWidth="1" stroke="currentColor" />
        <rect x="10" y="30" width="10" height="26" strokeWidth="1" stroke="currentColor" fill="none" />
        <rect x="24" y="18" width="12" height="38" strokeWidth="1" stroke="currentColor" fill="none" />
        <rect x="40" y="38" width="14" height="18" strokeWidth="1" stroke="currentColor" fill="none" />
        <line x1="24" y1="24" x2="36" y2="24" strokeWidth="1" stroke="currentColor" />
        <line x1="24" y1="32" x2="36" y2="32" strokeWidth="1" stroke="currentColor" />
      </svg>
    ),
  },
  {
    key: "book",
    label: "کتاب",
    svg: (
      <svg viewBox="0 0 64 64" aria-hidden="true">
        <line x1="32" y1="12" x2="32" y2="52" strokeWidth="1" stroke="currentColor" />
        <path
          d="M32 12 C 20 8, 8 10, 8 14 L 8 50 C 20 46, 28 48, 32 52"
          strokeWidth="1"
          stroke="currentColor"
          fill="none"
        />
        <path
          d="M32 12 C 44 8, 56 10, 56 14 L 56 50 C 44 46, 36 48, 32 52"
          strokeWidth="1"
          stroke="currentColor"
          fill="none"
        />
      </svg>
    ),
  },
  {
    key: "compass",
    label: "پرگار",
    svg: (
      <svg viewBox="0 0 64 64" aria-hidden="true">
        <circle cx="32" cy="10" r="2.5" strokeWidth="1" stroke="currentColor" fill="none" />
        <line x1="32" y1="13" x2="20" y2="54" strokeWidth="1" stroke="currentColor" />
        <line x1="32" y1="13" x2="44" y2="54" strokeWidth="1" stroke="currentColor" />
        <path d="M14 58 A 20 20 0 0 1 50 58" strokeWidth="1" stroke="currentColor" fill="none" />
      </svg>
    ),
  },
  {
    key: "pen-nib",
    label: "قلم",
    svg: (
      <svg viewBox="0 0 64 64" aria-hidden="true">
        <path d="M32 6 L46 40 L32 58 L18 40 Z" strokeWidth="1" stroke="currentColor" fill="none" />
        <line x1="32" y1="20" x2="32" y2="50" strokeWidth="1" stroke="currentColor" />
        <circle cx="32" cy="16" r="2" strokeWidth="1" stroke="currentColor" fill="none" />
      </svg>
    ),
  },
  {
    key: "globe",
    label: "کره",
    svg: (
      <svg viewBox="0 0 64 64" aria-hidden="true">
        <circle cx="32" cy="32" r="26" strokeWidth="1" stroke="currentColor" fill="none" />
        <ellipse cx="32" cy="32" rx="10" ry="26" strokeWidth="1" stroke="currentColor" fill="none" />
        <line x1="6" y1="32" x2="58" y2="32" strokeWidth="1" stroke="currentColor" />
        <line x1="9" y1="20" x2="55" y2="20" strokeWidth="1" stroke="currentColor" />
        <line x1="9" y1="44" x2="55" y2="44" strokeWidth="1" stroke="currentColor" />
      </svg>
    ),
  },
  {
    key: "layered-sheets",
    label: "لایه‌های کاغذ",
    svg: (
      <svg viewBox="0 0 64 64" aria-hidden="true">
        <rect x="10" y="18" width="34" height="26" strokeWidth="1" stroke="currentColor" fill="none" />
        <rect x="16" y="12" width="34" height="26" strokeWidth="1" stroke="currentColor" fill="none" />
        <rect x="22" y="6" width="34" height="26" strokeWidth="1" stroke="currentColor" fill="none" />
      </svg>
    ),
  },
];

export function getPublicationIcon(key) {
  return PUBLICATION_ICONS.find((icon) => icon.key === key)?.svg ?? null;
}
